import React, { ChangeEvent, FC } from 'react';
import { TextField } from '@mui/material';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { Button } from 'src/components/Button';
import { PasswordInput } from 'src/components/Forms/FormInputs/PasswordInput';
import { Form, InputsWrapper } from 'src/components/Forms/SignInForm/styled';
import { Link } from 'src/components/Link/styled';
import { ROUTE_SOURCES } from 'src/constants/routeSources';
import { useGoogleAnalytics } from 'src/hooks/useGoogleAnalytics';

export interface SignInFormValues {
  password: string;
  email: string;
}

interface SignInFormProps {
  onSubmit: SubmitHandler<SignInFormValues>;
  loading: boolean;
}

export const SignInForm: FC<SignInFormProps> = ({ onSubmit, loading }) => {
  const { trackFormSubmit, trackFormStart } = useGoogleAnalytics();
  const {
    formState: { errors, isValid },
    register,
    setValue,
    handleSubmit,
  } = useFormContext<SignInFormValues>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setValue(name as keyof SignInFormValues, value, { shouldValidate: true });
  };

  const handleFormStart = () => {
    trackFormStart('signin', 'auth');
  };

  const handleFormSubmit = (data: SignInFormValues) => {
    trackFormSubmit('signin', 'auth');
    onSubmit(data);
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <InputsWrapper>
        <TextField
          {...register('email', { onChange: handleChange })}
          label="Email"
          name="email"
          error={!!errors.email}
          helperText={errors.email?.message || ' '}
          onFocus={handleFormStart}
        />
        <PasswordInput
          error={!!errors.password}
          helperText={errors.password?.message || ' '}
          label="Password"
          name="password"
          onChange={handleChange}
        />
      </InputsWrapper>
      <Link to={`/${ROUTE_SOURCES.FORGOT_PASSWORD}`}>Forgot password?</Link>
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid}
        loading={loading}
      >
        Log In
      </Button>
    </Form>
  );
};
